//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';
import { Button, WithUnison } from 'unison';

import Icon from '@components/atoms/icon/Icon';

interface Props {
  shouldDisplayExtendedTip: boolean;
}

const IntelligentProductTaggingInfoTip = ({
  shouldDisplayExtendedTip,
}: Props) => {
  return (
    <WithUnison>
      <IptHoverButton isDisplayingTip={shouldDisplayExtendedTip}>
        <Icon name='lightbulb' />
        {shouldDisplayExtendedTip && (
          <ExpandedTipWrapper>
            Bazaarvoice AI has detected possible products
          </ExpandedTipWrapper>
        )}
      </IptHoverButton>
    </WithUnison>
  );
};

const IptHoverButton = styled(Button)<{ isDisplayingTip: boolean }>(
  ({ isDisplayingTip, theme }) => `
  cursor: default;
  padding: 5px 7px;
  border-radius: ${theme.borderRadii.pill};
  margin-left: ${theme.spacings[2]};
  margin-top: ${theme.spacings[2]};
  opacity: ${isDisplayingTip ? 1.0 : 0.6};
  width: ${isDisplayingTip ? '380px' : '32px'};
  height: 32px;
  transition: all 0.3s ease-out 0s;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 4;  // Neccesary to place the tip over the bounding boxes and spatial tags which have z-index 2 and 3
`,
);

const ExpandedTipWrapper = styled.div(
  ({ theme }) => `
  padding: 0px ${theme.spacings[2]};
`,
);

export default IntelligentProductTaggingInfoTip;
